"use client";

import { useMemo } from "react";
import { HighlightSelectView } from "./select-highlight";
import { FocusedHighlightView } from "./focused-highlight";
import { HIGHLIGHT_CONFIG, HighlightMaterials } from "./highlights";
import { useNotebookContext } from "../../../hooks/useNotebook";
import { useCommunication } from "@/lib/CommunicationWrapper";

export function HighlightsInterface() {
  const { highlights, currentPage, navigatePage, removeHighlight } =
    useNotebookContext();

  const category =
    currentPage.type === "highlight_category"
      ? currentPage.value
      : currentPage.type === "source_highlight_category"
      ? currentPage.highlight_category
      : null;

  const selectedHighlight =
    currentPage.type === "highlight"
      ? currentPage.value
      : currentPage.type === "source_highlight"
      ? currentPage.highlight
      : null;

  const config = useMemo(
    () => HIGHLIGHT_CONFIG.find((c) => c.id === category),
    [category]
  );

  const { navigatePage: navigateBCPage } = useCommunication();

  const selectChatView = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const returnUrl = urlParams.get("return");
    // if referred from files AI, return there instead
    if (returnUrl) navigateBCPage(null, {});
    else
      navigatePage(
        currentPage.type === "source_highlight" ||
          currentPage.type === "source_highlight_category"
          ? { type: "source", value: currentPage.source }
          : { type: "chat" }
      );
  };
  const selectHighlight = (highlight: HighlightMaterials) =>
    navigatePage({ type: "highlight", value: highlight });

  const items = useMemo(
    () => (category ? highlights.filter((h) => h.type === category) : []),
    [highlights, category]
  );

  if (selectedHighlight) {
    return (
      <FocusedHighlightView
        highlight={selectedHighlight}
        onBack={selectChatView}
        rightTopBar={
          currentPage.type === "source_highlight" ||
          currentPage.type === "source_highlight_category"
        }
      />
    );
  }

  return (
    <HighlightSelectView
      category={category}
      items={items}
      onSelect={selectHighlight}
      onBack={selectChatView}
      onDelete={removeHighlight}
      rightTopBar={
        currentPage.type === "source_highlight" ||
        currentPage.type === "source_highlight_category"
      }
    />
  );
}
